<template>
    <div class="footer-content">
        <div class="left">
            <div class="ft-20">Game Type</div>
            <div class="ft-18">RPG</div>
            <div class="ft-20">App Store</div>
            <div>
                <span class="ft-18 mr-24">Google Play</span>
                <span class="ft-18">App Store</span>
            </div>
        </div>
        <div class="right">
            <div style="cursor: pointer;">
                <span class="ft-20" @click="toPolicy">Privacy Policy</span>
                <span class="ft-20 line">|</span>
                <span class="ft-20" @click="toService">Terms of Service</span>
            </div>
            <div class="ft-18">@{{ config.copyright }}</div>
            <div class="ft-18">Contact Us: {{ config.email }}</div>
        </div>
    </div>
</template>
<script>
import config from "../config.js";
export default {
    data() {
        return {
            config
        }
    },
    methods: {
        toPolicy() {
            window.open(config.policy, "newW");
        },
        toService() {
            window.open(config.term, "newW");
        }
    }
}
</script>
<style lang="scss" scoped>
.footer-content{
    padding-top: 30px;
    width: 100%;
    height: 170px;
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .left{
        margin-left: 280px;
    }
    .right{
        margin-right: 280px;
    }
}
.ft-20{
    font-size: 20px;
    font-weight: 600;
}
.ft-18{
    font-size: 18px;
}
.mr-24{
    margin-right: 24px;
}
.line{
    margin: 0 30px;
}
@media screen and (max-width: 768px) {
    .footer-content{
        .left{
            margin-left: 40px;
        }
        .right{
            margin-right: 40px;
        }
    }
    .line{
        margin: 0 10px;
    }
}
</style>